export var defaultMonthOptions = {
    width: 7,
    height: 6
};
//# sourceMappingURL=_defaults.js.map


//////////////////
// WEBPACK FOOTER
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/ngx-bootstrap/datepicker/reducer/_defaults.js
// module id = ../../../../ngx-bootstrap/datepicker/reducer/_defaults.js
// module chunks = 4